var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-tab-alert-wrapper"},[_c('v-alert',{attrs:{"type":"info"}},[_c('span',{staticClass:"s c-helper"},[_vm._v(_vm._s(_vm.$t('alert-message')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }